import { useState, useEffect } from 'react';
import apiClient from '../../api/apiClient';
import RoleAccessHeader from '../../components/hris/rbac/RoleAccessHeader';
import RoleAccessFilters from '../../components/hris/rbac/RoleAccessFilters';
import RoleAccessTable from '../../components/hris/rbac/RoleAccessTable';
import RoleFormModal from '../../components/hris/rbac/RoleFormModal';

export default function RoleAccessManagement() {
  const [roles, setRoles] = useState([]);
  const [rolePermissions, setRolePermissions] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDivision, setSelectedDivision] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [orgData, rolePermsData] = await Promise.all([
        apiClient.get('/hris/organization'),
        apiClient.get('/hris/role-permissions').catch(() => ({ rolePermissions: [] })),
      ]);

      // Get roles with division information
      const roles = orgData.roles || [];
      const departments = orgData.departments || [];

      // Map division names to roles
      const rolesWithDivisions = roles.map((role: any) => ({
        ...role,
        division_name: role.division_id
          ? departments.find((dept: any) => dept.id === role.division_id)?.name
          : null,
      }));

      // Filter only active roles
      const activeRoles = rolesWithDivisions.filter((role: any) => role.status === 'active');
      setRoles(activeRoles);
      setDepartments(departments);
      setRolePermissions(rolePermsData.rolePermissions || []);
    } catch (error) {
      // Error loading data
    } finally {
      setLoading(false);
    }
  };

  const handleAddRole = () => {
    setShowAddModal(true);
  };

  const handleModalClose = () => {
    setShowAddModal(false);
  };

  const handleRoleAdded = () => {
    loadData(); // Reload data after adding role
  };

  return (
    <div className="space-y-6">
      <RoleAccessHeader onAddRole={handleAddRole} />
      <RoleAccessFilters
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        selectedDivision={selectedDivision}
        setSelectedDivision={setSelectedDivision}
        departments={departments}
      />
      <RoleAccessTable
        roles={roles}
        rolePermissions={rolePermissions}
        loading={loading}
        searchTerm={searchTerm}
        selectedDivision={selectedDivision}
      />
      <div className="text-sm text-gray-500">
        Menampilkan{' '}
        {
          roles.filter((role: any) => {
            const matchesSearch =
              role.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
              role.code?.toLowerCase().includes(searchTerm.toLowerCase());
            const matchesDivision =
              !selectedDivision ||
              (role.division_id && role.division_id.toString() === selectedDivision);
            return matchesSearch && matchesDivision;
          }).length
        }{' '}
        dari {roles.length} role
      </div>

      <RoleFormModal isOpen={showAddModal} onClose={handleModalClose} onSuccess={handleRoleAdded} />
    </div>
  );
}
